export const THROW_ERROR = 'THROW_ERROR';
export const CLEAR_ERROR = 'CLEAR_ERROR';



// WEBPACK FOOTER //
// ./src/constants/error.js